import React, { useContext } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { getMenuAdminLogManagement } from '@totem/components/ui_components/menus/mainMenu/admin_logManagement';
import TabContentMenu from '@totem/components/ui_components/menus/tabContentMenu';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const LogManagementPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard>
        <TabContentMenu items={getMenuAdminLogManagement(userProfile)} />
      </IBCard>
    </ContentLayout>
  );
};

export default LogManagementPage;
